module.exports = __webpack_public_path__ + "img/CovidSector_Infographics_1.89a9e31d.png";